module.exports = __webpack_public_path__ + "img/hollow_star.01770320.svg";